<template>
  <div class="home">
    <Nav></Nav>
    <div class="home-box">
      <div class="home-inner">
        <div class="banner-box">
          <homeBanner @handleSendFlag="handleGetFlag"></homeBanner>
          <div class="waveWrapper waveAnimation">
            <div class="waveWrapperInner bgBottom">
              <div class="wave waveBottom"></div>
            </div>
          </div>
        </div>
        <!--    AI操作系统    -->
        <div class="home-content">
          <AISystem ref="aiSystem"></AISystem>
        </div>

        <!--    职能部门    -->
        <div class="home-department">
          <ThirdScreen></ThirdScreen>
        </div>

        <!--    自研框架    -->
        <div>
          <FourthScreen ref="fourthScreen"></FourthScreen>
        </div>

        <div class="modulebox cooperation-box" v-show="cooperationList.length">
          <div class="title">合作伙伴</div>
          <div class="srolllist-logo-box">
            <div class="left-opacity"></div>
            <div :class="['scrollist-logo-inner', scrollCount > 1 ? 'scroll' : '']">
              <template v-for="scrollItemIdx in scrollCount">
                <div :key="scrollItemIdx" :class="['cooperator-list-box',screenWidth > scrollMaxWidth ? 'middlecenter' : '',]" :style="{ transform: `translateX(${scrollStyleX}px)` }">
                  <div v-for="(subList, idxList) in cooperationList" class="cooperator-listmain-box" :key="idxList" :ref="`logolist${idxList}`">
                    <div v-for="(item, idx) in subList" :key="idx" class="cooperator-item">
                      <div class="cooperator-logo" :style="`background:url(${item.icon}) no-repeat center center;background-size: contain;`"></div>
                      <div class="cooperator-name">{{ item.text }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="right-opacity"></div>
          </div>

          <div class="apply-button" @click="handleShowDialog">立即申请体验</div>
        </div>
        <div class="register-box" v-if="!userInfo">
          <div class="bg"></div>
          <div class="register-main-box">
            <img class="people-img" src="@/assets/people.png" alt="people"/>
            <div class="reg-box">
              <div class="welcome-title">欢迎加入独自开</div>
              <div class="welcome-subtitle">WELCOME TO JOIN US</div>
              <div class="form-box" @click="handleToRegister">
                <el-input
                    :readonly="true"
                    class="custom-input txt-phone"
                    v-model="user_phone"
                    placeholder="请输入手机号"
                    maxlength="11"
                ></el-input>
                <el-button class="custom-button btn-ff3333 btn-quicklyreg">
                  <div class="btn-body">
                    <span>快速注册</span>
                    <i class="el-icon-right"></i>
                  </div>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </div>
    <ApplyTaste
        ref="dialogApplyTaste"
        :title="'立即申请体验'"
    ></ApplyTaste>
<!--    <ButtonFeedback></ButtonFeedback>-->
    <el-dialog title="技术支持" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-content">
        <div>请通过扫描下方二维码添加相关人员获取相关技术支持</div>
        <div style="width: 200px; margin: 24px auto 0;"><img style="width: 100%; height: 100%;" src="../assets/user_TYP.jpg" alt=""></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ButtonFeedback from "@/components/ButtonFeedback";
import homeIndexApi from "@/api/homeIndex";
import pageCommon from "@/utils/pagecommon";
import taskApi from "@/api/task";
import countTo from 'vue-count-to';
import storage from "@/utils/customLocalStorage";
import accountApi from "@/api/account";
import auth from "@/utils/auth";
import AISystem from "@/views/Home/AISystem.vue";
import homeBanner from '@/views/Home/homeBanner.vue'
import ThirdScreen from '@/views/Home/ThirdScreen.vue'
import FourthScreen from '@/views/Home/FourthScreen.vue'
import ApplyTaste from "@/components/dialog/ApplyTaste.vue";
import DialogApplyInfo from "@/components/dialog/ApplyInfo.vue";
import absoutApi from "@/api/about";

export default {
  name: "Home",
  components: {
    DialogApplyInfo,
    Swiper,
    SwiperSlide,
    Nav,
    Footer,
    ButtonFeedback,
    countTo,
    AISystem,
    homeBanner,
    ThirdScreen,
    FourthScreen,
    ApplyTaste
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      dialogVisible: false,
      saveData001: "",
      saveData002: "",
      saveData003: "",
      featureList: [],
      cooperationList: [],
      overlaysceneList: [],
      swiperOption: {
        loop: true,
        autoplay: {
          duration: 3000,
        },
      },
      user_phone: "",
      screenWidth: 0,
      scrollCount: 1,
      scrollMaxWidth: 1555,
      scrollTimer: null,
      scrollStyleX: 0,
      scrollPlatformCount: 1,
      scrollPlatformMaxWidth: 1555,
      scrollPlatformStyleX: 0,
      scrollPlatformTimer: null,
      scrollFlag: false
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      return _this.$store.state.user;
    },
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acNavIndex", 0);
    _this.getTotalInfo();
    _this.getModInfo();
    _this.getBannerData();
    window.onresize = _this.getScreenWidth;
    _this.getScreenWidth();
    if (JSON.parse(storage.read('isAuto'))) {
      _this.handelAutoLogin()
    }
    if (this.userInfo.id_public_user_info != 92 && !this.userInfo.user_remark_001) {
      this.$confirm("检测到您的信息尚未完善，需要先完善个人信息", "提示", {
        type: "warning",
        showCancelButton: false,
        showClose: false,
      })
          .then(() => {
            this.$router.push({
              path: "/complateInfo?id=" + this.userInfo.id_public_user_info,
            });
          });
    }
    window.addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    handleGetFlag(data) {
      this.$refs.aiSystem.animateFlag = data
    },
    scrollToTop() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 660 && scrollTop < 700) {
        this.$nextTick(() => {
          if (this.$refs.aiSystem) {
            this.$refs.aiSystem.animateFlag = true
          }
        })

      }
    },
    /*
    * 工具包下载
    * */
    handleDownLoaTool() {
      if (!this.userInfo || this.userInfo.user_phone === 'x-teamer') {
        this.$confirm("您还未登录,不能下载工具包, 请先注册或登录", "未登录", {
          type: "warning",
          showCancelButton: false,
          showClose: false,
        })
            .then(() => {
              this.$router.push({path: "/login"});
            });
      } else {
        this.$router.push(({path: '/accountCenter'}))
      }
    },
    /*
    * 设置自动登录
    * */
    handelAutoLogin() {
      let _this = this;
      let requestData = {
        user_phone: JSON.parse(storage.read('user')).user_phone,
        password_user: JSON.parse(storage.read('password')),
        isloading: true,
      };
      pageCommon.apiRequestCommon(accountApi, "sysUserpwdLogin", requestData).then(
          (res) => {
            let resUserInfo = res.public_user_info;
            let expire = 3600 * 24 * 30;
            let strToken = JSON.stringify({
              id_public_user_info: resUserInfo.id_public_user_info,
              user_type: resUserInfo.user_type,
              nick_name: resUserInfo.nick_name,
              weichat_img: resUserInfo.weichat_img,
              isVip: resUserInfo.isVip,
              userMoney: resUserInfo.userMoney
            });
            auth.setToken(strToken, expire);
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              // _this.$message.error(err.data.msg);
            }
          }
      );
    },
    /*
    * 需求发布
    * */
    handleReleaseDemand() {
      if (!this.userInfo || this.userInfo.user_phone === 'x-teamer') {
        this.$confirm("您还未登录,不能下载工具包, 请先注册或登录", "未登录", {
          type: "warning",
          showCancelButton: false,
          showClose: false,
        })
            .then(() => {
              this.$router.push({path: "/login"});
            });
      } else {
        this.$router.push({path: '/mydemanddetail', query: {o: 'new'}})
      }
    },
    /*
    * 技术支持
    * */
    handleShowDialog() {
      console.log(this.userInfo)
      /*if (!this.userInfo || this.userInfo.id_public_user_info === 92) {
        this.$confirm('你还未登录,请先完成登录~', '提示', {
          type: 'warning'
        }).then(() => {

        }).catch(() => {

        })

        return false;
      }*/
      this.$refs["dialogApplyTaste"].showDialog = true
    },

    pageError: function () {
      let _this = this;
      _this.overlaysceneList = [];
      _this.cooperationList = [];
      _this.featureList = [];
    },

    dealwithCooperativeInfo: function (list) {
      let _this = this;
      let len = list.length;
      let row = 1;
      if (len <= 8) {
        row = 1;
      } else if (len > 8 && len <= 16) {
        row = 2;
      } else if (len > 16) {
        row = 3;
      }
      _this.createCooperativeInfoList(row, list);
    },

    createCooperativeInfoList: function (row, data) {
      let _this = this;
      let rowSize = 8;
      let cooperationList = [];
      if (data.length > 24) {
        rowSize =
            data.length % 3 === 0
                ? parseInt(data.length / 3)
                : parseInt(data.length / 3) + 1;
      }
      for (let i = 0; i < row; i++) {
        let tmp = [];
        for (
            let j = i * rowSize;
            j < (i + 1) * rowSize && j < data.length;
            j++
        ) {
          const element = data[j];
          tmp.push({
            icon: element.mid_table_remark_003,
            text: element.mid_table_remark_001,
          });
        }
        cooperationList.push(tmp);
      }
      _this.cooperationList = cooperationList;
      _this.$nextTick(() => {
        _this.getListBoxWidth();
      });
    },
    getListBoxWidth: function () {
      let _this = this;
      let items = document.querySelector(".cooperator-listmain-box");
      _this.$nextTick(() => {
        _this.scrollMaxWidth = items && items.offsetWidth ? items.offsetWidth : 1555;
        _this.getScreenWidth();
      });
    },
    getScreenWidth: function () {
      let _this = this;
      _this.screenWidth = document.body.clientWidth;
      if (_this.screenWidth > _this.scrollMaxWidth) {
        _this.scrollCount = 2;
        _this.scrollStyleX = 0;
        _this.scrollCooperativeList();
      } else {
        _this.scrollCount = 1;
        _this.scrollStyleX = 0;
        cancelAnimationFrame(_this.scrollTimer);
      }
    },
    handleToRegister: function () {
      let _this = this;
      _this.$router.push("/register");
    },
    scrollCooperativeList() {
      let _this = this;
      cancelAnimationFrame(_this.scrollTimer);
      _this.scrollTimer = requestAnimationFrame(function fn() {
        let offsetX = 1;
        let tempX = _this.scrollStyleX - offsetX;
        if (tempX <= -_this.scrollMaxWidth) {
          if (tempX == -_this.scrollMaxWidth) {
            _this.scrollStyleX = 0;
          } else {
            _this.scrollStyleX = -_this.scrollMaxWidth;
          }
        } else {
          _this.scrollStyleX -= offsetX;
        }
        _this.scrollTimer = requestAnimationFrame(fn);
      });
    },
    getTotalInfo: function () {
      let _this = this;
      pageCommon
          .apiRequestCommon(homeIndexApi, "getTotalData", {isloading: true})
          .then(
              (res) => {
                _this.saveData001 = res.saveData001;
                _this.saveData002 = res.saveData002;
                _this.saveData003 = res.saveData003;
                _this.overlaysceneList = res.list001;
                if (res.list002) {
                  _this.dealwithCooperativeInfo(res.list002);
                } else {
                  _this.cooperationList = [];
                }
              },
              (err) => {
                _this.cooperationList = [];
                _this.overlaysceneList = [];
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
          );
      return;
    },
    getModInfo: function () {
      let _this = this;
      let requestData = {
        isloading: true,
      };
      pageCommon.apiRequestCommon(taskApi, "getAllTaskData", requestData).then(
          (res) => {
            _this.dealwithModInfo(res.page_content);
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
      );
      return;
    },
    dealwithModInfo: function (list) {
      let _this = this;
      let len = list.length;
      let row = 1;
      if (len <= 8) {
        row = 1;
      } else if (len > 8 && len <= 16) {
        row = 2;
      } else if (len > 16) {
        row = 3;
      }
      _this.createModInfoList(row, list);
    },
    createModInfoList: function (row, data) {
      let _this = this;
      let rowSize = 8;
      let featureList = [];
      if (data.length > 24) {
        rowSize =
            data.length % 3 === 0
                ? parseInt(data.length / 3)
                : parseInt(data.length / 3) + 1;
      }
      for (let i = 0; i < row; i++) {
        let tmp = [];
        for (
            let j = i * rowSize;
            j < (i + 1) * rowSize && j < data.length;
            j++
        ) {
          const element = data[j];
          tmp.push({
            icon: element.mid_table_remark_003,
            text: element.mid_table_remark_001,
          });
        }
        featureList.push(tmp);
      }
      _this.featureList = featureList;
      _this.$nextTick(() => {
        _this.getModListBoxWidth();
      });
    },
    getModListBoxWidth: function () {
      let _this = this;
      let items = document.querySelector(".mode-listmain-box");
      _this.$nextTick(() => {
        _this.scrollPlatformMaxWidth =
            items && items.offsetWidth ? items.offsetWidth : 1944;
        _this.getModScreenWidth();
      });
    },
    getModScreenWidth: function () {
      let _this = this;
      _this.screenWidth = document.body.clientWidth;
      if (_this.screenWidth < _this.scrollPlatformMaxWidth) {
        _this.scrollPlatformCount = 2;
        _this.scrollPlatformStyleX = 0;
        _this.scrollModList();
      } else {
        _this.scrollPlatformCount = 1;
        _this.scrollPlatformStyleX = 0;
        cancelAnimationFrame(_this.scrollPlatformTimer);
      }
    },
    scrollModList() {
      let _this = this;
      cancelAnimationFrame(_this.scrollPlatformTimer);
      _this.scrollPlatformTimer = requestAnimationFrame(function fn() {
        let offsetX = 1;
        let tempX = _this.scrollPlatformStyleX - offsetX;

        if (tempX <= -_this.scrollPlatformMaxWidth) {
          if (tempX == -_this.scrollPlatformMaxWidth) {
            _this.scrollPlatformStyleX = 0;
          } else {
            _this.scrollPlatformStyleX = -_this.scrollPlatformMaxWidth;
          }
        } else {
          _this.scrollPlatformStyleX -= offsetX;
        }
        _this.scrollPlatformTimer = requestAnimationFrame(fn);
      });
    },

    getBannerData() {
      pageCommon
          .apiRequestCommon(absoutApi, "getHomeBanner", { isloading: false })
          .then(
              (res) => {
                console.log(res)
                this.$refs.fourthScreen.bannerList = res.page_content
              },
              (err) => {
                if (err.sysUserLoginError) {
                  this.$message.error("系统异常，请稍后刷新重试！");
                  _this.bannerList = [];
                } else {
                  this.$message.error(err.data.msg);
                  this.bannerList = [];
                }
              }
          );
    }
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.less";

.home {
  overflow: hidden;

  .home-box {
    width: 100%;
    color: #ffffff;
    font-size: 30px;
    overflow: hidden;

    .home-inner {
      min-width: 1200px;
      padding-top: 80px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;

      .banner-box {
        position: relative;
        width: 100%;
        height: 900px;
        box-sizing: border-box;
        background: url("https://global-application-001.downline.cn/www.duzikai.com/goods_image/E53KxK1700707679112.png") no-repeat center center #07060b;
        background-size: 100% 100%;

        .logo-slogan-box {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 149px;
          box-sizing: border-box;

          .logo {
            width: 336px;
            height: 118px;
            margin-right: 11px;
          }

          .faitsystem_text {
            width: 845px;
            height: 94px;
            // font-size: 100px;
            // font-family: Source Han Serif SC;
            // font-weight: bold;
            // color: #EB333A;
            // line-height: 20px;
          }
        }

        .banner-description {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 auto;
          width: 686px;
          height: 39px;
          font-size: 40px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: .8em;
          margin-top: 44px;
          text-align: center;

          i {
            font-style: normal;
          }
        }

        .hellowworld {
          text-align: center;
          width: 657px;
          height: 183px;
          margin-top: 110px;
        }
      }

      .modulebox {
        .title {
          width: 100%;
          text-align: center;
          font-size: 56px;
          letter-spacing: 6px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #222222;
          //line-height: 20px;
        }

        .subtitle {
          margin-bottom: 80px;
          width: 100%;
          text-align: center;
          margin-top: 25px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #999999;
          line-height: 20px;
        }
      }

      .cooperation-box {
        width: 100%;
        padding-top: 101px;

        .srolllist-logo-box {
          position: relative;
          width: 100%;
          overflow: hidden;
          margin-top: 88px;

          .scrollist-logo-inner {
            position: relative;
            display: flex;
            align-items: center;
            overflow: hidden;
          }

          .left-opacity {
            width: 460px;
            height: 660px;
            background: linear-gradient(90deg, rgba(255,255,255,1) 60%,rgba(255,255,255,0));
            position: absolute;
            left: 0;
            top: 0;
            z-index: 9;
          }
          .right-opacity {
            width: 460px;
            height: 660px;
            background: linear-gradient(270deg, rgba(255,255,255,1) 60%,rgba(255,255,255,0));
            position: absolute;
            right: 0;
            top: 0;
            z-index: 9;
          }
        }

        .cooperator-list-box {
          position: relative;
          flex-shrink: 0;

          &.middlecenter {
            margin: 0 auto;
          }

          .cooperator-listmain-box {
            position: relative;
            width: auto;
            display: flex;
            flex-wrap: nowrap;
            margin-top: -25px;

            &:first-child {
              margin-top: 0;
            }

            .cooperator-item {
              position: relative;
              width: 267px;
              height: 218px;
              background: url("../assets/bg-cooperative.png") no-repeat;
              background-size: 100% 100%;
              flex-shrink: 0;
              margin-left: -24px;
              display: flex;
              flex-direction: column;
              align-items: center;

              .cooperator-logo {
                position: relative;
                width: 219px;
                height: 130px;
                margin: 20px auto 0;
              }

              .cooperator-name {
                font-size: 16px;
                line-height: 16px;
                font-family: "SourceHanSansCN";
                text-align: center;
                font-weight: 700;
                color: rgb(8, 7, 12);
                margin-top: 14px;
              }
            }
          }
        }

        .apply-button {
          width: 421px;
          height: 186px;
          color: #fff;
          border-radius: 5px;
          font-family: 'Lato', sans-serif;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          background-image: url(../assets/image/apply_button.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin: 0 auto 48px;
          font-size: 32px;
          line-height: 160px;
          font-weight: 600;
          overflow: hidden;
          z-index: 9;
        }
      }

      .register-box {
        position: relative;
        width: 100%;
        height: 284px;
        margin-top: 80px;

        .bg {
          position: absolute;
          width: 100%;
          height: 210px;
          bottom: 0;
          left: 0;
          background-color: rgb(7, 6, 11);
        }

        .register-main-box {
          position: relative;
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;

          .people-img {
            width: 546px;
            height: 284px;
            margin-left: -40px;
          }

          .reg-box {
            position: relative;
            margin-right: 107px;
            margin-top: 116px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .welcome-title {
              font-size: 24px;
              font-family: "SourceHanSansCN";
              color: rgb(255, 255, 255);
              line-height: 24px;
              font-weight: 700;
            }

            .welcome-subtitle {
              font-size: 16px;
              line-height: 16px;
              font-family: "SourceHanSansCN";
              color: rgba(255, 255, 255, 0.4);
              margin-top: 16px;
            }

            .form-box {
              position: relative;
              margin-top: 24px;
              display: flex;
              align-items: center;

              .txt-phone {
                width: 400px;
                border: none;
              }

              .btn-quicklyreg {
                width: 120px;
                height: 46px;
                line-height: 46px;
                font-size: 14px;
                margin-left: 14px;

                .btn-body {
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  .el-icon-right {
                    font-size: 18px;
                    // color: #ffffff;
                    margin-left: 5px;
                  }
                }

                // .icon-go {
                //   width: 16px;
                //   height: 10px;
                //   margin-left: 13px;
                // }
              }
            }
          }
        }

        // height: 284px;
        // margin-top: 80px;
        // margin-top: 80px;
        // background: url("../assets/bg_quick_reg.png") no-repeat;
        // background-size: 100% auto;
      }
    }
  }
}

.entrance-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 96px auto 0;
  position: relative;
  z-index: 9;

  .entrance-item {
    cursor: pointer;
    width: 220px;
    height: 80px;
    background: url("../assets/icon_item_bg.png") no-repeat;
    background-size: 100% 100%;
    border: 1px solid #EC4040;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 6px 26px 1px rgba(128, 3, 8, 0.48);

    .item-icon {
      width: 48px;
      height: 48px;
      margin-right: 22px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.home-content {
  padding-top: 90px;
}

@-webkit-keyframes shiny-btn1 {
  0% {
    top: -60px;
    left: 36px;
    width: 50%;
  }
  100% {
    width: 100%;
    top: 120px;
    left: 200px;
  }
}


@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1)
  }
  50% {
    transform: translateX(-25%) translateZ(0) scaleY(0.55)
  }
  100% {
    transform: translateX(-50%) translateZ(0) scaleY(1)
  }
}

.waveWrapper {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.waveWrapperInner {
  position: absolute;
  width: 100%;
  overflow: hidden;
  height: 100%;
  bottom: -24px;
  //background-image: linear-gradient(to top, #86377b 20%, #27273c 80%);
}

.bgBottom {
  z-index: 5;
}
.wave {
  position: absolute;
  left: 0;
  width: 200%;
  height: 100%;
  background-repeat: repeat no-repeat;
  background-position: 0 bottom;
  transform-origin: center bottom;
}
.waveBottom {
  background-image: url(../assets/wave-bot.png);
  background-size: 50% 100px;
}
.waveAnimation .waveBottom {
  animation: move_wave 15s linear infinite;
}
</style>
